export enum LieuType {
  CFA = 'CFA',
  MAISON = 'Maison',
  ENTREPRISE = 'Entreprise',
}
